module.exports = __webpack_public_path__ + "img/topic4-2.1dcce4d3.png";